import { inject } from '@angular/core';
import type { RedirectFunction } from '@angular/router';

import { CLIENT_ROLES, INTERNAL_ROLES, type AppRole } from './session.model';
import { SessionService } from './session.service';

/**
 * The authorized home for a role set (R-005/R-107): internal roles land on
 * /overview, client roles on /home, anything else on /sign-in. Shared by the
 * landing redirect, the post-sign-in navigation, and the roleGuard deny path
 * so the three cannot drift.
 */
export function authorizedHomePath(roles: readonly AppRole[]): '/overview' | '/home' | '/sign-in' {
  if (roles.some((role) => INTERNAL_ROLES.includes(role))) return '/overview';
  if (roles.some((role) => CLIENT_ROLES.includes(role))) return '/home';
  return '/sign-in';
}

/**
 * Role-based landing redirect (R-005): returns a string path synchronously —
 * never a promise — so no navigation is delayed.
 */
export const landingRedirect: RedirectFunction = () =>
  authorizedHomePath(inject(SessionService).session().roles);
